import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { GOOGLE_FLOWS, type GoogleFlow } from '../utils/googleFlow';
import { getThemeModeByFlow, type ThemeMode } from '../theme/themeMode';
import type { RootState } from '.';

export const plansSlice = createSlice({
  name: 'plans',
  initialState: {
    flowType: 'default',
    googleFlow: GOOGLE_FLOWS.LEGACY as GoogleFlow,
    landing: '',
    plan: '',
    planDetails: null,
    couponDetails: {
      couponPrice: 0,
      couponName: '',
    },
    upsellPlan: '',
    defaultPlanId: '',
  },
  reducers: {
    setFlowType: (state, action) => {
      if (action.payload) {
        state.flowType = action.payload;
      }
    },
    setLanding: (state, action) => {
      state.landing = action.payload ?? '';
    },
    setPlan: (state, action) => {
      state.plan = action.payload;
    },
    setPlanDetails: (state, action) => {
      state.planDetails = action.payload;
    },
    setCouponDetails: (state, action) => {
      state.couponDetails = action.payload;
    },
    setDefaultPlanId: (state, action) => {
      state.defaultPlanId = action.payload;
    },
    setUpsellPlan: (state, action) => {
      state.upsellPlan = action.payload;
    },
    setGoogleFlow: (state, action: PayloadAction<GoogleFlow>) => {
      state.googleFlow = action.payload;
    },
  },
});

export const {
  setPlan,
  setFlowType,
  setLanding,
  setPlanDetails,
  setDefaultPlanId,
  setCouponDetails,
  setUpsellPlan,
  setGoogleFlow,
} = plansSlice.actions;

export const selectPlan = (state: any) => state.plans.plan;
export const selectFlowType = (state: any) => state.plans.flowType;
export const selectThemeMode = (state: RootState): ThemeMode =>
  getThemeModeByFlow(state.plans.flowType);
export const selectLanding = (state: any) => state.plans.landing ?? '';
export const selectPlanDetails = (state: any) => state.plans.planDetails;
export const selectPlanCoupon = (state: any) => state.plans.couponDetails;
export const selectDefaultPlanId = (state: any) => state.plans.defaultPlanId;
export const selectUpsellPlan = (state: any) => state.plans.upsellPlan;
export const selectGoogleFlow = (state: any): GoogleFlow =>
  state.plans.googleFlow ?? GOOGLE_FLOWS.LEGACY;

export default plansSlice.reducer;
